/**
 * Base URL de l'API d'authentification/sync, déduite de l'hôte courant :
 *  - prod (geo-nerd.com)  → https://api.geo-nerd.com
 *  - reste (dev local)    → http://localhost:4321
 */
const host = typeof window !== "undefined" ? window.location.hostname : "";
export const API_BASE = host.endsWith("geo-nerd.com")
    ? "https://api.geo-nerd.com"
    : "http://localhost:4321";
